export default "__VITE_ASSET__CPRyf_X0__"